import { render } from "./EventSocials.vue?vue&type=template&id=61478cb7&scoped=true"
import script from "./EventSocials.vue?vue&type=script&lang=js"
export * from "./EventSocials.vue?vue&type=script&lang=js"

import "./EventSocials.vue?vue&type=style&index=0&id=61478cb7&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61478cb7"]])

export default __exports__